var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-rich",style:(_vm.wrapStyle)},[_c('img',{ref:"imgRef",style:(_vm.style),attrs:{"src":_vm.src},on:{"load":_vm.imgLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }